import apiClient from '../client';

export interface FeeReminderStudent {
  /** Alias of admission_id — required by the DataTable<T extends { id: number }> constraint. */
  id: number;
  admission_id: number;
  student_name: string;
  branch_name: string;
  fee_amount: number;
  paid_amount: number;
  balance: number;
  parent_phone: string | null;
  has_app: boolean;
  device_token_count: number;
}

export interface FeeReminderPreview {
  rows: FeeReminderStudent[];
  total: number;
  reachable: number;
  total_balance: number;
}

export interface FeeReminderSendResult {
  sent: number;
  skipped: number;
  total: number;
}

export type Quarter = 'Q1' | 'Q2' | 'Q3' | 'Q4';

/** Placeholders supported in both title and body templates. */
export const REMINDER_PLACEHOLDERS = [
  { token: '{{student_name}}',  description: "Student's full name" },
  { token: '{{quarter}}',       description: 'Quarter code (e.g. Q1)' },
  { token: '{{quarter_label}}', description: 'Quarter with months (e.g. Q1 (Apr-Jun))' },
  { token: '{{balance}}',       description: 'Outstanding balance in ₹' },
] as const;

/** Mirrors the server-side defaults so the UI can show and reset them. */
export const DEFAULT_REMINDER_TITLE = "📋 {{quarter}} Fee Reminder — Li'l Miracles";
export const DEFAULT_REMINDER_BODY  =
  "Dear parent, {{student_name}}'s {{quarter_label}} fee balance of ₹{{balance}} is pending. Please pay at the earliest.";

export interface FeeReminderSendPayload {
  quarter: Quarter;
  academic_year: string;
  /** Optional title template with {{placeholder}} tokens. Falls back to server default when omitted. */
  custom_title?: string;
  /** Optional body template with {{placeholder}} tokens. Falls back to server default when omitted. */
  custom_body?: string;
}

export interface FeeReminderSendSinglePayload {
  admission_id: number;
  quarter: Quarter;
  academic_year: string;
  custom_title?: string;
  custom_body?: string;
}

export const feeRemindersApi = {
  preview: (params: { quarter: Quarter; academic_year: string }) =>
    apiClient
      .get<{ data: FeeReminderPreview }>('/admin/fee-reminders/preview', { params })
      .then((r) => r.data.data),

  send: (payload: FeeReminderSendPayload) =>
    apiClient
      .post<{ data: FeeReminderSendResult }>('/admin/fee-reminders/send', payload)
      .then((r) => r.data.data),

  sendSingle: (payload: FeeReminderSendSinglePayload) =>
    apiClient
      .post<{ data: { success: boolean; title: string; body: string } }>('/admin/fee-reminders/send-single', payload)
      .then((r) => r.data.data),
};
